<template>
  <div ref="wrap" class="home-wrap">
    <slot></slot>
  </div>
</template>

<script>
import ScrollTrigger from '@terwanerik/scrolltrigger'
export default {
  data(){
    return {
      currentModule: 0,
    }
  },
  watch:{
    currentModule(newV){
      this.$emit('current',newV)
    }
  },
  mounted(){
    this.initAnimation()
    this.currentModule = 1
  },
  methods: {
    initAnimation() {
      this.trigger = new ScrollTrigger()
      // childNodes查询更快
      this.$refs.wrap.childNodes.forEach((element, index) => {
        if(element.className){
          if (element.className.includes('column-wrap') || element.className.includes('footer')) {
            // 设置触发属性
            element.setAttribute('data-trigger', index)
          }
        }
        
      })
      // 触发绑定
      this.trigger.add('[data-trigger]', {
        toggle: {
          callback: {
            in: (trigger) => {
              let curIndex = trigger.element.getAttribute('data-trigger')
              setTimeout(() => {
                this.currentModule = curIndex > this.currentModule ? curIndex : this.currentModule
              }, 400);
            },
          },
        },
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.home-wrap{
  width: 100%;
  overflow: scroll;
  position: absolute;
  top: 72px;
}
</style>